/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Autofill_SuccessInputs */

const en_directory_submit_autofill_success = /** @type {(inputs: Directory_Submit_Autofill_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Form filled. Please review the details.`)
};

const zh_directory_submit_autofill_success = /** @type {(inputs: Directory_Submit_Autofill_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表单已填写，请检查内容。`)
};

/**
* | output |
* | --- |
* | "Form filled. Please review the details." |
*
* @param {Directory_Submit_Autofill_SuccessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_autofill_success = /** @type {((inputs?: Directory_Submit_Autofill_SuccessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Autofill_SuccessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_autofill_success(inputs)
	return zh_directory_submit_autofill_success(inputs)
});
export { directory_submit_autofill_success as "directory.submit.autofill_success" }